module.exports = __webpack_public_path__ + "img/checkmark.815c2fa3.svg";